import type { Permission } from '@/shared/api'
import type { AccessPair } from '@/shared/lib'

/**
 * `/v1/reports/*` — отчёты и взаиморасчёты. Пара прав — зеркало `@ActingAs` бэка: клиент строит
 * свой отчёт (`own` — `report.view`), менеджер — глазами клиента (`onBehalf` — `manager.orders.view`,
 * бэк проверяет модификатор этим правом, иначе `ACTING_AS_FORBIDDEN`). `accepts: ['account']` —
 * ручки отчётов принимают ещё и фильтр по учётной записи (`account`, только вместе с `client`).
 *
 * Полного вида менеджера нет (`full` не задан): без клиента менеджер — режим `needs-client`, в меню
 * `/reports` ему не показывается, а разрез по клиенту открывается вкладкой профиля
 * (`/clients/:client/reports`). Пункт меню `/reports` остаётся у клиента (режим `own`).
 */
export const REPORTS_ACCESS: AccessPair = {
  own: 'report.view',
  onBehalf: 'manager.orders.view',
  accepts: ['account'],
}

/**
 * Запрос акта сверки (`POST /v1/reports/reconciliation`) закрыт правом `reconciliation.request` —
 * оно есть только у клиента. Модификатора «от имени» ручка не принимает (`400 acting.not-supported`).
 */
export const RECONCILIATION_ACCESS: Permission = 'reconciliation.request'
